
export type GetExploreContent200PageAllOfThreeContentItemBasicInfoAllOfTwoType = typeof GetExploreContent200PageAllOfThreeContentItemBasicInfoAllOfTwoType[keyof typeof GetExploreContent200PageAllOfThreeContentItemBasicInfoAllOfTwoType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetExploreContent200PageAllOfThreeContentItemBasicInfoAllOfTwoType = {
  TWEET: 'TWEET',
  TOPIC: 'TOPIC',
  PROJECT: 'PROJECT',
} as const;
